import React from 'react';
import {Dropdown, DropdownContext} from '~library/molecules/Dropdown';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {DuplicateIcon} from '~library/svg/DuplicateIcon';

export const DuplicateDropdown = ({
  index,
  onDuplicateItem,
  onCopySlotsToEmptyDate,
  isOnlySignupOption = false,
}) => (
  <Dropdown
    buttonClassName="slot-toolbar__button"
    buttonVariant="unstyled-button"
    data-qa-id={`duplicate-dropdown-${index}`}
    buttonQaIdModifier="duplicate-trigger"
  >
    <DuplicateIcon />
    <DropdownContext.Consumer>
      {({toggle}) => (
        <>
          <div className="dropdown__menu-item" key="create-multiple-days">
            <Button
              variant="transparent"
              size="small"
              data-qa-id={`copy-date-button-${index}`}
              onClick={() => {
                toggle();
                return onDuplicateItem(index);
              }}
            >
              <DuplicateIcon />
              <Typography variant="paragraph2">Copy date and its contents</Typography>
            </Button>
          </div>
          <div className="dropdown__menu-item" key="copy-slots-to-empty-dates">
            <Button
              data-qa-id={`copy-slots-button-${index}`}
              variant="transparent"
              size="small"
              onClick={() => {
                toggle();
                return onCopySlotsToEmptyDate(index);
              }}
              disabled={isOnlySignupOption}
            >
              <DuplicateIcon />
              <Typography variant="paragraph2">Copy signup slots to other dates</Typography>
            </Button>
          </div>
        </>
      )}
    </DropdownContext.Consumer>
  </Dropdown>
);
